import { createReducer, on } from '@ngrx/store';
import { EntityTypesState } from './entity-types.state';
import { EntityTypesActions } from './entity-types.actions';

const initialState: EntityTypesState = {
  loaded: false,
  loading: false,
  entityTypes: {}
};

export const entityTypesReducer = createReducer(
  initialState,
  on(EntityTypesActions.get_entity_types_start, (state): EntityTypesState => {
    return { ...state, loading: true, loaded: false };
  }),
  on(EntityTypesActions.get_entity_types_success, (state, payload) => {
    return {
      ...state,
      entityTypes: payload.types,
      loaded: true,
      loading: false
    };
  })
);
